import merge from 'lodash/fp/merge';
import get from 'lodash/get';

const initialState = {};

export default function reducer(state = initialState, action) {
  if (get(action, 'entities')) {
    return merge(state, action.entities);
  }
  return state;
}
